import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationtaxiserviceinmumbai() {



  const cardData =
  {
    keyword: 'Outstation Taxi Service in Mumbai ',
    heading: 'Shambhu Cabs: Outstation Taxi Service in Mumbai',
    headingDescription: 'Shambhu Cabs offers reliable Outstation Taxi Service in Mumbai, providing safe, comfortable, and convenient travel for families, tourists, corporate professionals, and groups planning intercity journeys. Our fleet of well-maintained hatchbacks, sedans, SUVs, luxury cars, and tempo travellers ensures a smooth and enjoyable ride to destinations like Pune, Mahabaleshwar, Shirdi, Nashik, Lonavala, Goa, and across India. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes long-distance travel stress-free and dependable. For comfort, safety, and a seamless outstation travel experience, Shambhu Cabs is your trusted choice for Outstation Taxi Service in Mumbai.',

    top: 'Top Places to Visit in Mumbai Outstation with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located just 85 km from Mumbai, Lonavala and Khandala are the most popular outstation hill stations known for misty mountains, lush valleys, waterfalls, and scenic viewpoints. Tiger Point, Bhushi Dam, Lion’s Point, Rajmachi Fort, and Pawna Lake are top attractions. A perfect weekend escape for families, friends, and couples looking for fresh air and greenery."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Mahabaleshwar is Maharashtra’s most scenic hill station, famous for strawberry farms, Venna Lake, Mapro Garden, Arthur’s Seat, and Wilson Point. Panchgani offers beautiful viewpoints like Table Land and Sydney Point. A Mumbai–Mahabaleshwar outstation cab trip is ideal for a 2–3 day relaxing getaway in cool weather."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa is a peaceful, European-style private hill city near Pune featuring lakeside promenades, colorful buildings, adventure activities, cafes, and photography spots. It’s perfect for outings, romantic trips, and weekend holidays from Mumbai."
  },
  {
    "title": "Nashik",
    "description": "One of India’s oldest and holiest cities, Nashik is known for Sula Vineyards, Trimbakeshwar Jyotirlinga, Panchavati, Ramkund, and scenic surroundings. Wine lovers, pilgrims, and nature enthusiasts often book Mumbai–Nashik outstation cabs for one-day or two-day trips."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is India’s most visited spiritual destination and home to Shri Sai Baba Temple. Millions of devotees visit every year for darshan, meditation, and blessings. The town also features Shani Shingnapur nearby, making Mumbai–Shirdi outstation trips highly popular."
  },
  {
    "title": "Alibaug",
    "description": "A coastal paradise just 95 km from Mumbai, Alibaug offers clean beaches, sea forts, water sports, cafes, and peaceful stays. Popular spots include Alibaug Beach, Varsoli Beach, Nagaon, Murud-Janjira, and Kashid Beach. Ideal for beach holidays, photoshoots, and weekend road trips."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a beautiful hill destination known for the Vipassana International Academy, Bhatsa River Valley, Camel Valley, Kalsubai Peak, and ancient forts. Its pleasant climate, greenery, and trekking trails make it an excellent outstation choice from Mumbai."
  },
  {
    "title": "Kolad",
    "description": "Kolad is the adventure capital of Maharashtra, famous for Kundalika River White Water Rafting, camping, kayaking, and zip-lining. It’s a top choice for adventure groups booking outstation cab services from Mumbai."
  },
  {
    "title": "Daman & Silvassa",
    "description": "Daman offers clean beaches, Portuguese colonial forts, churches, and seaside resorts. Silvassa, the capital of Dadra & Nagar Haveli, features wildlife parks, tribal museums, lakes, and serene forests. Both destinations are perfect for calm and budget-friendly weekend outings from Mumbai."
  },
  {
    "title": "Pune",
    "description": "Pune is a major cultural and IT hub known for historical monuments, hill viewpoints, shopping, nightlife, and gardens. Popular attractions include Aga Khan Palace, Shaniwar Wada, Saras Baug, Sinhagad Fort, and shopping streets. Mumbai–Pune outstation cabs are frequently booked for business trips, travel, and leisure."
  },
  {
    "title": "Matheran",
    "description": "Asia’s only vehicle-free hill station, Matheran offers untouched forests, toy train rides, and 30+ viewpoints like Echo Point, Louisa Point, and Charlotte Lake. It provides a peaceful, pollution-free escape from Mumbai’s rush."
  },
  {
    "title": "Saputara",
    "description": "Situated on the Maharashtra–Gujarat border, Saputara is a scenic hill station known for its cool weather, boating lake, Gira Waterfalls, step gardens, and tribal culture. It's ideal for a long weekend outstation trip from Mumbai."
  }
],



"services": [
  {
    "name": "Outstation Cab Mumbai",
    "description": "Outstation Cab Mumbai provides reliable, comfortable, and premium long-distance travel from Mumbai to destinations across Maharashtra and India. With professional chauffeurs, clean AC vehicles, and 24×7 availability, this service ensures stress-free intercity travel for families, professionals, and tourists. Whether it’s a weekend getaway, business trip, temple yatra, or multi-day tour, customers enjoy smooth highway travel, flexible schedules, transparent pricing, and doorstep pickup-drop convenience."
  },
  {
    "name": "Mumbai Long-Distance Taxi",
    "description": "Mumbai Long-Distance Taxi is designed for travellers going to distant cities with maximum comfort and safety. This service includes experienced long-route drivers, spacious sedans/SUVs, luggage-friendly vehicles, and smooth expressway connectivity. Ideal for outstation vacations, corporate travel, medical trips, and statewide transfers, it guarantees secure cabin conditions, timely departures, and professional trip handling from start to finish."
  },
  {
    "name": "One-Way Outstation Cab Mumbai",
    "description": "One-Way Outstation Cab Mumbai offers economical and convenient single-direction travel for customers who do not require a return trip. Perfect for relocations, airport transfers, hotel check-ins, business meetings, or city-to-city shifts, this service provides transparent pricing, quick booking, clean vehicles, and punctual drivers for smooth long-distance rides without extra return charges."
  },
  {
    "name": "Round Trip Outstation Cab Mumbai",
    "description": "Round Trip Outstation Cab Mumbai provides comfortable two-way travel for travellers planning a complete return journey. This service includes flexible stay durations, planned halts, experienced chauffeurs, and customizable itineraries. Suitable for short trips, weekend tours, pilgrimages, and family vacations, this option guarantees cost efficiency and reliability for extended travel plans."
  },
  {
    "name": "Best Outstation Service Mumbai",
    "description": "Best Outstation Service Mumbai promises high-quality intercity cab travel with premium vehicles, skilled drivers, GPS-enabled safety, and 24×7 trip coordination. Customers enjoy seamless booking, transparent fares, on-time pickups, and smooth expressway rides. This service is ideal for luxury travellers, corporate bookings, long trips, and hassle-free city-to-city journeys."
  },
  {
    "name": "Affordable Outstation Taxi",
    "description": "Affordable Outstation Taxi offers budget-friendly pricing for Mumbai travellers looking for a reliable long-distance cab without compromising on comfort or safety. With economical sedans, fuel-efficient SUVs, and trained drivers, this service ensures value-for-money outstation travel. Ideal for families, students, and frequent travellers needing cost-effective transportation."
  },
  {
    "name": "SUV Outstation Cab Mumbai",
    "description": "SUV Outstation Cab Mumbai provides spacious and powerful vehicles such as Ertiga, Innova, and Crysta for comfortable long-distance road journeys. Perfect for families, groups, and travellers with luggage, the service ensures superior comfort, stable highway performance, and safe travel across hilly terrains and expressways."
  },
  {
    "name": "Sedan Outstation Taxi",
    "description": "Sedan Outstation Taxi offers smooth, comfortable, and budget-friendly sedan options for intercity travel. With AC sedans, trained drivers, and clean interiors, this service is well-suited for small families, couples, executives, and solo travellers looking for comfort and affordability on long routes."
  },
  {
    "name": "Mumbai Outstation Travel",
    "description": "Mumbai Outstation Travel provides customized tour planning, flexible routing, and professional cab services for destinations like Pune, Nashik, Goa, Mahabaleshwar, Shirdi, Surat, Ahmedabad, Bangalore, and more. The service includes premium cars, experienced chauffeurs, and safe highway rides tailored to the traveller’s needs."
  },
  {
    "name": "Expressway Outstation Cab",
    "description": "Expressway Outstation Cab ensures fast and smooth travel via major expressways such as Mumbai–Pune Expressway, Samruddhi Mahamarg, and Mumbai–Vadodara Highway. Ideal for time-sensitive travellers, business customers, and long-distance rides requiring speed, safety, and efficiency."
  },
  {
    "name": "24×7 Outstation Taxi Service",
    "description": "24×7 Outstation Taxi Service offers round-the-clock availability for immediate outstation travel needs. Whether it’s late-night departures, emergency trips, weekend tours, or early-morning travel, this service guarantees safe drivers, clean cars, and reliable operations at any hour."
  },
  {
    "name": "Family Outstation Cab Mumbai",
    "description": "Family Outstation Cab Mumbai is designed for comfortable and safe family travel with spacious vehicles, child-friendly interiors, secure luggage space, and experienced drivers. Perfect for vacations, hill stations, temple trips, and summer holidays, it ensures a pleasant travel experience for every family member."
  },
  {
    "name": "Corporate Outstation Cab Mumbai",
    "description": "Corporate Outstation Cab Mumbai provides premium chauffeur-driven travel solutions for business executives, corporate staff, and official intercity transfers. Features include professional drivers, fixed-route pricing, invoice support, comfortable seating, and efficient long-distance travel for meetings or events."
  },
  {
    "name": "Mumbai Tourist Taxi",
    "description": "Mumbai Tourist Taxi offers curated intercity holiday packages for popular tourist destinations. With customizable itineraries, expert drivers familiar with routes, and comfortable AC vehicles, this service is perfect for travellers exploring beaches, hill stations, wildlife parks, heritage sites, and pilgrimage locations."
  },
  {
    "name": "Safe Outstation Taxi Mumbai",
    "description": "Safe Outstation Taxi Mumbai focuses on secure long-distance travel with GPS-enabled vehicles, verified drivers, sanitized cabs, and controlled driving practices. Ideal for families, senior citizens, solo female travellers, and night trips, it ensures maximum safety throughout the journey."
  },
  {
    "name": "Online Outstation Booking Mumbai",
    "description": "Online Outstation Booking Mumbai offers instant digital booking with live fare estimates, vehicle options, secure payments, and quick confirmations. Users can book sedans, SUVs, or premium cars online for same-day or advance outstation travel plans with complete convenience."
  },
  {
    "name": "Outstation Pickup Drop Mumbai",
    "description": "Outstation Pickup Drop Mumbai provides seamless city-to-city transfers with doorstep pickup and destination drop-off. Ideal for travellers needing simple, direct, and comfortable one-way travel to any outstation location without extra charges or delays."
  }
],

"tableData": [
  ["Outstation Cab Mumbai", "Mumbai Long-Distance Taxi"],
  ["One-Way Outstation Cab Mumbai", "Round Trip Outstation Cab Mumbai"],
  ["Best Outstation Service Mumbai", "Affordable Outstation Taxi"],
  ["SUV Outstation Cab Mumbai", "Sedan Outstation Taxi"],
  ["Mumbai Outstation Travel", "Expressway Outstation Cab"],
  ["24×7 Outstation Taxi Service", "Family Outstation Cab Mumbai"],
  ["Corporate Outstation Cab Mumbai", "Mumbai Tourist Taxi"],
  ["Safe Outstation Taxi Mumbai", "Online Outstation Booking Mumbai"],
  ["Outstation Pickup Drop Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Outstation Taxi Service in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable outstation taxi services in Mumbai, perfect for weekend trips, family vacations, business travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, spacious, air-conditioned, and regularly serviced vehicles to ensure a smooth and comfortable outstation trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers Skilled in Long-Distance Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with major outstation routes from Mumbai, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer clear, upfront pricing that includes fuel, tolls, and driver allowances, giving you a stress-free outstation taxi experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist you with bookings, route planning, and travel assistance."
  },
  {
    "WhyChooseheading": "Flexible Outstation Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized outstation packages tailored to your travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All taxis are thoroughly cleaned and sanitized before every trip to provide a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and efficient service, making your outstation travel from Mumbai smooth and worry-free."
  }
]





















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide outstation taxi services in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers reliable outstation taxi services from Mumbai to various destinations across India, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'How can I book an outstation taxi from Mumbai?',
    answer: 'You can easily book an outstation taxi from Mumbai through our website, mobile app, or by contacting our 24x7 customer support team for assistance.',
  },
  {
    question: 'What types of taxis are available for outstation travel from Mumbai?',
    answer: 'Shambhu Cabs offers a wide range of vehicles for outstation travel, including sedans, SUVs, luxury cars, and Tempo Travellers suitable for both small and large groups.',
  },
  {
    question: 'Are the drivers experienced for outstation taxi services from Mumbai?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with long-distance travel to ensure a smooth and safe journey to your outstation destination.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for outstation taxi bookings?',
    answer: 'Absolutely. You can choose any pickup and drop-off location in Mumbai and for your outstation destination, making the journey flexible and convenient.',
  },
  {
    question: 'Is outstation taxi service available 24x7 from Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock outstation taxi services, allowing you to plan your travel according to your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for outstation taxi services from Mumbai?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure your safety and well-being throughout the trip.',
  },
  {
    question: 'What payment options are available for outstation taxi bookings in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for outstation taxi bookings.',
  },
  {
    question: 'Is customer support available during the outstation taxi journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you during your entire outstation taxi journey from Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sunil Joshi',
    feedback: 'The outstation taxi service by Shambhu Cabs was excellent. The driver was professional, and the car was comfortable for our long journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Shah',
    feedback: 'I highly recommend Shambhu Cabs for outstation taxi bookings. Smooth booking, professional driver, and a safe trip made our journey stress-free.',
    rating: 5,
  },
];





































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Taxi Service in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/outstation-cab-mumbai.jpg",
  "description": "Book reliable outstation taxi services in Mumbai with Shambhu Cabs. We provide one-way, round trip, sedan, and SUV cabs for long-distance travel, corporate trips, family journeys, and tourist rides.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "850",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/outstation-taxi-service-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Outstation Taxi Service in Mumbai | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book outstation cab services from Mumbai with Shambhu Cabs. Sedan and SUV taxis available for one-way and round trips, long-distance travel, family trips, corporate travel, and tourist rides."
  />

  <meta
    name="keywords"
    content="Outstation Cab Mumbai, Mumbai Long-Distance Taxi, One-Way Outstation Cab Mumbai, Round Trip Outstation Cab Mumbai, Best Outstation Service Mumbai, Affordable Outstation Taxi, SUV Outstation Cab Mumbai, Sedan Outstation Taxi, Mumbai Outstation Travel, Expressway Outstation Cab, 24×7 Outstation Taxi Service, Family Outstation Cab Mumbai, Corporate Outstation Cab Mumbai, Mumbai Tourist Taxi, Safe Outstation Taxi Mumbai, Online Outstation Booking Mumbai, Outstation Pickup Drop Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationtaxiserviceinmumbai;